import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyCiZJzq3MaP6r5kOmYXax_QSyWyiA78cF0',
  authDomain: 'dihaw-ai.firebaseapp.com',
  projectId: 'dihaw-ai',
  appId: '1:439374198572:web:1bc0732b0df5291100de89',
}

export const firebaseApp = initializeApp(firebaseConfig)
export const firebaseAuth = getAuth(firebaseApp)

export const googleAuthProvider = new GoogleAuthProvider()
googleAuthProvider.addScope('email')
googleAuthProvider.addScope('profile')
googleAuthProvider.setCustomParameters({ prompt: 'select_account' })
